import {FormDefinitionFieldModel} from '../../../field/api/entity/formDefinitionField.model';

export class FormDefinitionGroupFieldModel {
    id: string;
    index: number;
    fieldDefinition: FormDefinitionFieldModel;
    defaultValue: string;
    label: string;
}
